module.exports = __webpack_public_path__ + "static/media/select.f848f265.svg";